module.exports = __webpack_public_path__ + "static/media/Mesprit_gaussian2.2a0a19df.png";